import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
import { DEFAULT_DATE_FORMAT } from 'api/models';
import {
  DateRange,
  getValueFromDateRange,
} from 'components/organisms/projects-report/common/range-picker/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { UsersReportRecord } from 'components/organisms/users-report/types';
import { ApiFilter } from 'utils/simple-search-filter/simple-search-filter';
import { ApiUsersReport } from './api-types';
import { asUsersReport } from './mapper';

const baseUrl = '/reports/users';

class UsersReportClient extends HttpClient {
  public getReports = async (
    range: DateRange,
    filters: FieldFilter[],
    match: QueryCombinerType,
  ): Promise<UsersReportRecord[]> => {
    const [startDate, endDate] = getValueFromDateRange(range).map((x) =>
      x.format(DEFAULT_DATE_FORMAT),
    );

    return this.get<ApiUsersReport>(
      `${baseUrl}?${ApiFilter.toQueryStringFormat(filters)}&${stringify(
        {
          startDate,
          endDate,
          match: filters.length ? match : null,
        },
        { skipNull: true },
      )}`,
    ).then(asUsersReport);
  };

  public exportAsCSV = async (
    range: DateRange,
    filters: FieldFilter[],
    match: QueryCombinerType,
  ): Promise<string> => {
    const [startDate, endDate] = getValueFromDateRange(range).map((x) =>
      x.format(DEFAULT_DATE_FORMAT),
    );

    return this.get<{ downloadUrl: string }>(
      `${baseUrl}/export?${ApiFilter.toQueryStringFormat(filters)}&${stringify(
        {
          startDate,
          endDate,
          match: filters.length ? match : null,
        },
        { skipNull: true },
      )}`,
    ).then((response) => response.downloadUrl);
  };
}

export const UsersReportAPI = new UsersReportClient();
